/* eslint-disable max-len */
import React, { FC } from "react";

/**
 * A functional React component that renders a Filter SVG icon UI element.
 */
export const IconFilter: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px">
        <ellipse cx="4" rx="2" ry="2" cy="3" />
        <ellipse cx="12" rx="2" ry="2" cy="8" />
        <ellipse cx="4" rx="2" ry="2" cy="13" />
        <path d="M 0 3 L 16 3" strokeLinecap="round" />
        <path d="M 0 13 L 16 13" strokeLinecap="round" />
        <path d="M 0 8 L 16 8" strokeLinecap="round" />
    </svg>
);
